// src/config/breadcrumbs.js
import {
    Dashboard,
    Settings,
    Cable,
    Schema,
    Token,
    Sync,
    PersonOutline,
    Business,
    Assignment,
    Storage,
    Code,
    Security,
    Chat as ChatIcon
  } from '@mui/icons-material';
  
  // Define all possible routes and their configurations
  export const routeConfig = {
    dashboard: {
      path: '/dashboard',
      label: 'Dashboard',
      icon: Dashboard
    },
    masterconnector: {
      path: '/master-connector',
      label: 'Master Connector',
      icon: Cable,
      parent: 'dashboard'
    },
    masterflow: {
      path: '/master-flow',
      label: 'Master Flow',
      icon: Schema,
      parent: 'dashboard'
    },
    connectortoken: {
      path: '/connector-token',
      label: 'Connector Token',
      icon: Token,
      parent: 'dashboard'
    },
    syncflow: {
      path: '/sync-flow',
      label: 'Sync Flow',
      icon: Sync
    },
    tenantusers: {
      path: '/tenant',
      label: 'Tenant Users',
      icon: Business,
      parent: 'dashboard'
    },
    profile: {
      path: '/profile',
      label: 'Profile',
      icon: PersonOutline
    },
    chathub: {
      path: '/chat-hub',
      label: 'Chat Hub',
      icon: ChatIcon
    },
  };
  
  // Helper function to generate breadcrumb path
export const generateBreadcrumbPath = (currentRoute) => {
  const breadcrumbs = [];
  let route = routeConfig[currentRoute];

  // Check if user is CDX user for conditional breadcrumb logic
  const isCdxUser = (() => {
    try {
      const cdxUser = localStorage.getItem('cdx_user');
      return cdxUser === 'true' || cdxUser === true;
    } catch (error) {
      console.error('Error reading cdx_user from localStorage:', error);
      return false;
    }
  })();

  // For non-CDX users, modify certain pages to use sync flow as parent instead of dashboard
  if (!isCdxUser && (currentRoute === 'connectortoken' || currentRoute === 'profile')) {
    // Add current page
    breadcrumbs.unshift({
      label: route.label,
      icon: route.icon,
      href: route.path
    });

    // Add sync flow as parent for non-CDX users
    const syncFlowRoute = routeConfig['syncflow'];
    if (syncFlowRoute) {
      breadcrumbs.unshift({
        label: syncFlowRoute.label,
        icon: syncFlowRoute.icon,
        href: syncFlowRoute.path
      });
    }

    return breadcrumbs;
  }

  // Default breadcrumb logic for CDX users or other routes
  if (route) {
    breadcrumbs.unshift({
      label: route.label,
      icon: route.icon,
      href: route.path
    });

    // Add parent routes
    while (route.parent) {
      route = routeConfig[route.parent];
      if (route) {
        breadcrumbs.unshift({
          label: route.label,
          icon: route.icon,
          href: route.path
        });
      }
    }
  }

  return breadcrumbs;
};